import React from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Image,
  Modal,
} from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import ThubBanner from "./template-parts/ThubBanner";
import styles from "../../../styles/CommonEntity.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { getMagazine, getVirtualEvent } from "../../../store/thubMethods";
import {
  MdShare,
  MdAdd,
  MdFavorite,
  MdFavoriteBorder,
  MdPlaylistAddCheck,
  MdMusicNote,
  MdVideocam,
  MdOutlineModeComment,
  MdPhotoCameraFront,
  MdPlayArrow,
  MdOutlineRemoveRedEye,
  //MdRemove,
} from "react-icons/md";
import NotFound from "../../ui/common/NotFound";
import { ComponentLoader } from "../../ui/common/LoadingSpinner";
import { scrollTop } from "../../../helper";
import { useLocation, useSearchParams } from "react-router-dom";
import Paginate from "../../ui/common/Paginate";
import DatePosted from "../../ui/common/DatePosted";
import VideoPlayer from "../../ui/VideoPlayer/VideoPlayer";
import { togglePlaying } from "../../../store/playerMethods";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import API from "../../../lib/api";

const VirtualEvent = () => {
  const dispatch = useDispatch();
  const profileData = useSelector((state) => state.auth.myProfile);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [pageData, setPageData] = useState([]);
  const [refresh,SetRefresh] = useState(false)

  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const selectedEvent = useRef({});
  const totalCount = useRef();
  const itemsPerPage = useRef();
  const offset = useRef();

  const handleLike = async(id,user) =>{
    const resp = await API.post("/api/features/virtualevent/liked-events/",{
      user:user,
      virtual_event:id
    })
    SetRefresh(!refresh)
    // console.log(resp,"resp data")
  }

  const handleDislike = async(liked) =>{
    const response = await API.delete(`api/features/virtualevent/liked-events/${liked}`)
    // console.log(response,"un")
    SetRefresh(!refresh)
  }

  useEffect(() => {
    setIsLoading(true);
    itemsPerPage.current = searchParams.get("limit") || 25;
    offset.current = searchParams.get("offset") || 0;
    dispatch(
      getVirtualEvent(
        location.search ? `${location.search}` : "?offset=0&limit=25"
      )
    ).then((data) => {
      setIsLoading(false);
      setPageData(data.data);
      totalCount.current = data.total_count;
    });

    let tout = setTimeout(() => scrollTop(), 100);
    return () => {
      clearTimeout(tout);
    };
  }, [searchParams,refresh]);

  return (
    <div className={styles.mainCont}>
      <ThubBanner
        mainTitle={"Virtual Events Library"}
        // subTitle={"Welcome to Podcaster Virtual Events"}
      />
      <Container>
        <Row>
          <Col md={3} className={`${styles.leftCont}`}>
            <Row className="sticky-top" style={{ top: "100px" }}>
              <Col className={`text-center`}>
                {/* <div
                  className="ratio ratio-1x1 overflow-hidden rounded-circle mx-auto"
                  style={{ maxWidth: "200px" }}
                >
                  <Image
                    src={profileData?.profile_image_details?.url}
                    style={{ objectFit: "cover" }}
                  />
                </div> */}
                <div className="my-3">
                  <h6 className="m-0">{`${profileData?.user?.first_name} ${profileData?.user?.last_name}`}</h6>
                  <small>{profileData?.role}</small>
                </div>
                <div className="d-grid">
                  <hr />
                  <Button className="mb-3 d-flex align-items-center">
                    One Platform{" "}
                    <MdPhotoCameraFront size={18} className="ms-auto" />
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={9} className={styles.rightCont}>
            <Paginate
              totalCount={totalCount.current}
              itemsPerPage={itemsPerPage.current}
              offset={offset.current}
              setSearchParams={setSearchParams}
            >
              {isLoading ? (
                <ComponentLoader>
                  <p className="m-0">
                    <em>
                      Please wait while we are loading the virtual events.
                    </em>
                  </p>
                </ComponentLoader>
              ) : pageData.length === 0 ? (
                <NotFound>No virtual event found.</NotFound>
              ) : (
                pageData.length > 0 &&
                pageData.map((vEvent, i) => (
                  <Row
                    className="g-0 overflow-hidden rounded mb-3 card flex-row"
                    key={`sos_${i}`}
                  >
                    <Col md={4}>
                      <div className="ratio ratio-4x3 overflow-hidden">
                        <Card.Img
                          variant="top"
                          className="rounded-0 grow smooth"
                          style={{ objectFit: "cover" }}
                          src={vEvent.thumbnail_file_origin?.url?.split("?")[0]}
                        ></Card.Img>
                      </div>
                    </Col>
                    <Col>
                      <div className="h-100 d-flex flex-column p-3">
                        <h6 className="text-muted">
                          {vEvent.title}
                          <br />
                          <small className="text-muted fw-regular">
                            <DatePosted date={vEvent.created_at} />
                          </small>
                        </h6>
                        <p className="small text-muted">{vEvent.description}</p>
                        <div className="ms-auto mt-auto d-flex">
                          <Button
                            variant="primary"
                            className="me-3"
                            style={{ fontSize: '18px', padding: '10px 30px' }}
                            onClick={() => {
                              setShow(true);
                              dispatch(togglePlaying(true));
                              selectedEvent.current = vEvent;
                            }}
                          >
                            View{" "}
                            <MdOutlineRemoveRedEye
                              style={{ verticalAlign: "sub" }}
                              size={16}
                            />
                          </Button>
                         {vEvent.liked?.liked === true ? (
                         <h3 style={{ cursor: "pointer" }}
                         onClick={(e)=>{
                          const likedid = vEvent.liked.liked_event_id
                          handleDislike(likedid)
                         }}
                         >
                            <AiFillHeart className="text-danger" />
                          </h3>
                         ):(
                          <h3 style={{ cursor: "pointer" }}
                          onClick={(e)=>{
                            const id = vEvent.id
                            const user = vEvent.user
                            handleLike(id,user)
                           }}
                          >
                          <AiOutlineHeart className="text-dark"/>
                          </h3>
                          )}

                          {/* mediaItem should go here */}
                        </div>
                      </div>
                    </Col>
                  </Row>
                ))
              )}
            </Paginate>
          </Col>
        </Row>
      </Container>
      <VideoModal setShow={setShow} show={show} data={selectedEvent.current} />
    </div>
  );
};

export default VirtualEvent;

function VideoModal({ setShow, show, data }) {
  const dispatch = useDispatch();
  const handleClose = () => {
    setShow(false);
    dispatch(togglePlaying(false));
  };
  // console.log(data, "data");
  return (
    <>
      <Modal centered size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton className="border-secondary">
          <Modal.Title>{data.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center overflow-hidden">
          {data.video_file_origin && (
            <VideoPlayer
              src={data.video_file_origin.url.split("?")[0]}
              placeholder={data.thumbnail_file_origin.url.split("?")[0]}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
